module.exports = __webpack_public_path__ + "60ff323e5d3195a050ddcfcebff8854f.png";